import styled from "styled-components";

export const AllFullContainer = styled.div`
    display: flex; 
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: #964F39;
    // overflow: hidden;
    margin-top: -20px;
    padding-top: 120px;
    padding-bottom: 160px;
`


export const FullContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%; 
    width: 100%;
    margin-bottom: 60px;
    minHeight: 200px;
`
export const TitleSection = styled.h2`
    display: flex;  
    width: 100%;
    font-size: 2rem;
    color: #FDDFC7; 
    margin-bottom: 20px;
    width: 90%;
    align-self: center;
`

export const FullWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 60px;
    height: 100%;
    margin-top: -20px;
    background: #964F39;

`

export const WrapperCard = styled.div`
    display: flex;
    margin: 10px;
    width: 90%;
    height: 300px;
    background: #FDDFC7;
    border-radius: 10px;
`
export const ImgCard = styled.img`
    width: 60%;
    margin-right: 10px;
    object-fit: cover;
    @media (max-width: 768px) {
        
}
`
export const WrapperInfos = styled.div`
    display: flex;
    width: 60%;
    height: 100%;
    flex-direction: column;
    background: #FDDFC7;
    padding: 10px;
    justify-content: space-between;
    // margin-left: 20px;
`
export const TitleCard  = styled.h2`
    font-size: 1.8rem;
    width: 100%;
    color: #964F39; 
    margin-bottom: 20px;
    overflow-y: hidden;
    @media (max-width: 768px) {
        font-size: 1.5rem;
} @media (max-width: 450px) {
        font-size: 1.2rem;
}
`
export const DescripionCard = styled.p`
    font-size: 1.2rem;
    width: 95%;
    color: #964F39;
    margin-bottom: 20px;
    overflow-y: hidden;
    @media screen and (max-width: 768px) {
        font-size: 0.8rem;
}

`
export const PriceCard = styled.p`
    display: flex;
    font-weight: bold;
    font-size: 1.8rem;
    color: #964F39;
    align-self: flex-end;
    justify-content: flex-end;
    overflow-y: hidden;
    @media screen and (max-width: 425px) {
        align-self: flex-start;
        font-size: 1.5rem;
}   
`

// Modal styles

export const ModalCloseButton = styled.button`
    font-size: 1.4rem;
    width: 50px;
    height: 50px;
    background: #E38339;
    border: none; 
    color: white; 
    padding: 10px; 
    position: absolute; 
    margin: -45px; 
    border-radius: 50%; 
    cursor: pointer;
    font-weight: bold;
    transition: all 0.2s ease-in-out;
    &:hover {
        color: #2E0011;
        transition: all 0.2s ease-in-out;
        scale: 1.1;
    }
`

export const WarningBox = styled.div`
    padding: 20px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 10px;
    max-width: 800px;
    background: #FFF3E9;
    border: 2px solid #964F39;
    border-radius: 8px;
    text-align: center;
    color: #964F39;
    font-size: 1.2rem;
    font-weight: 500;

    @media screen and (max-width: 768px) {
        margin: 20px;
        font-size: 1rem;
    }
`;
